export const freeServices = [
  {
    href: 'formSuccessFreeServicesTagMapLink',
    title: 'formSuccessFreeServicesTagMap',
  },
  {
    href: 'formSuccessFreeServicesTagConstructorLink',
    title: 'formSuccessFreeServicesTagConstructor',
  },
  {
    href: 'formSuccessFreeServicesTagReviewLink',
    title: 'formSuccessFreeServicesTagReview',
  },
  {
    href: 'formSuccessFreeServicesTagRatingLink',
    title: 'formSuccessFreeServicesTagRating',
  },
];
